import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import { requirePermission } from "@/lib/route-guards"
import { Perm } from "@/lib/permissions"
import { ProjectDetailPage } from "@/pages/projects/project-detail"

// Chat notifications deep-link here with ?chatMessage=<id> to scroll/highlight that message.
const projectDetailSearchSchema = z.object({
	chatMessage: z.coerce.number().int().positive().optional(),
})

export const Route = createFileRoute("/_authenticated/projects/$id/")({
	validateSearch: (search) => projectDetailSearchSchema.parse(search),
	beforeLoad: async ({ context }) => {
		await requirePermission(context, Perm.PROJECT_READ, { to: "/projects" })
	},
	component: ProjectDetailPage
})
